import {useMedia} from "react-use";
import tokens from "../theme/tokens";
import {ORIENTATION_TYPES, DEVICE_TYPES} from "../components/EnsureOrientationOnMobile";

export default function useDeviceInfo(){

  const isDesktop  = useMedia(tokens.desktopMediaQuery, false);
  const isMobile  = useMedia(tokens.mobileMediaQuery, false);
  const portrait = useMedia(`(orientation : ${ORIENTATION_TYPES.PORTRAIT})`);
  const landscape = useMedia(`(orientation : ${ORIENTATION_TYPES.LANDSCAPE})`)
  const orientation = portrait ? ORIENTATION_TYPES.PORTRAIT : ORIENTATION_TYPES.LANDSCAPE;

  const deviceType = () => {
    const ua = navigator.userAgent;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return DEVICE_TYPES.TABLET;
    } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return DEVICE_TYPES.MOBILE;
    }
    return DEVICE_TYPES.DESKTOP;
  };

  return {
    isMobile,
    isDesktop,
    orientation,
    portrait,
    landscape,
    deviceType: deviceType()
  };

}
